import { render, staticRenderFns } from "./SystemNoticeHost.vue?vue&type=template&id=421eefc0"
import script from "./SystemNoticeHost.vue?vue&type=script&lang=js"
export * from "./SystemNoticeHost.vue?vue&type=script&lang=js"
import style0 from "./SystemNoticeHost.vue?vue&type=style&index=0&id=421eefc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports